import { useEffect, useState } from "react";
import { IOpenPanel } from "../../../../../Interfaces/IPanel";
import { IntegracionService } from "../../../../../services/auxiliar/IntegracionService";
import { IPostRazon, IRazonSincronia, IRazonSync } from "../../../../../Interfaces/estadoEquipos/IEstadoEquipo";
import { IResponseApiFluent, codigosRespuesta } from "../../../../../Interfaces/base/IResponse";

export const UsePanelSincronizarRazon=(props:IOpenPanel)=>{
    const [LoadingSincronizar,setLoadingSincronizar]=useState<boolean>(false)
    const [razonesSync,setRazonesSync]=useState<IRazonSincronia>({razonesEliminar:[],razonesInsertar:[],razonesIntegrar:[]})
    const [status, setStatus] = useState<codigosRespuesta>(0);
    const [mensaje, setMensaje] = useState<string>("");
    const [loading,setLoading]=useState<boolean>(false)
    const getRazonesSincronizar=()=>{
        setLoadingSincronizar(true)
        IntegracionService.GetRazones().then((res)=>{
           if(res.status==200){
            setLoadingSincronizar(false)
            setRazonesSync(res.data)
           }
        }).catch((e)=>{
            setLoadingSincronizar(false)
        })
    }
    const SyncronizarRazones=()=>{
        setLoading(true)
        IntegracionService.PostRazon(razonesSync).then((res)=>{
            if(res.status==200){
                setStatus(200)
                setMensaje(res.data.mensaje);
                setTimeout(() => {
                    props.reload?.();
                    reset()
                }, 3000)
            }else{
                setStatus(500)
            }
            setLoading(false)
        }).catch((e)=>{
            if (
                e.response?.data &&
                'type' in e.response.data &&
                'title' in e.response.data &&
                'status' in e.response.data &&
                'instance' in e.response.data &&
                'errors' in e.response.data
              ) {
                const errorResponse = e.response.data as IResponseApiFluent;
                const mensajeError = errorResponse.errors.join('\n');
                setMensaje(mensajeError);
              } else {
                console.log('Error detallado:', e);
                setMensaje("Error Inesperado");
              }
              setStatus(500);
              setLoading(false);
        })
    }
    const reset=()=>{
        setMensaje("")
        setStatus(0)
        props.onDismiss()
    }
    useEffect(()=>{
        if(props.isOpen){
            getRazonesSincronizar()
        }
    },[props.isOpen])
    return {razonesSync,LoadingSincronizar,reset,status,mensaje,loading,SyncronizarRazones}
}